// Filters 2.0
export const TYPE = 'FILTERS_ABUNDANCE_METADATA';

export const filterAbundanceUrl = '/api/relevance/v2/filters';

export const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case `REQUEST_${TYPE}`: {
            return {
                ...state,
                url: action.url,
                isFetching: true,
                isError: false
            };
        }
        case `RECEIVE_${TYPE}`: {
            return {
                data: { ...action.data.metadata },
                url: action.url,
                isFetching: false,
                isError: false
            };
        }
        case `ERROR_${TYPE}`: {
            return {
                ...state,
                url: action.url,
                isFetching: false,
                isError: true
            };
        }

        case `CLEAR_${TYPE}`: {
            return initialState;
        }

        default:
            return state;
    }
};
